import Swiper from 'swiper'
import SwiperCore, { Navigation } from 'swiper/core'

SwiperCore.use([Navigation])

export default class ProductSliderHomepage {
  constructor(component) {
    this.dom = {
      $component: component,
      $container: component.querySelector('.js-productSliderContainer'),
      $prev: component.querySelector('.js-productSliderPrev'),
      $next: component.querySelector('.js-productSliderNext'),
    }
    this.state = {

    }
    this.mount()
    this.bindToWindow()
  }

  mount() {
    this.initSlider()
  }

  initSlider() {
    const { dom } = this
    const swiper = new Swiper(dom.$container, {
      slidesPerView: 'auto',
      navigation: {
        prevEl: dom.$prev,
        nextEl: dom.$next,
      },
    })
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.ProductSliderHomepage = this
  }
}
